<style lang="scss" scoped>
.slide-4 {
  background-image: url(../../../assets/module1/slide4/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 90px;
  padding-left: 160px;
  padding-right: 160px;
  height: calc(100% - 90px);
}
p {
  color: white;
}
h1 {
  color: #c5d43b;
  font-size: 80px;
  line-height: 96px;
}
.intro {
  margin-bottom: 20px;
}
.dropzone {
  position: absolute;
  width: 1100px;
  height: 50px;
  bottom: 183px;
  left: 650px;
}
.drop {
  position: absolute;
  font-size: 30px;
  color: #f8dc61;
  top: -1px;
  width: 250px;
  height: 50px;
  line-height: 59px;
  text-align: center;
  &.drop-1 {
    left: -20px;
  }
  &.drop-2 {
    left: 450px;
  }
  &.drop-3 {
    left: 850px;
  }
}
.drag {
  height: 71px;
  width: 268px;
  overflow: hidden;
  background-image: url("../../../assets/module1/slide4/drag.png");
  background-size: 100% 100%;
  font-size: 35px;
  font-family: "Kookycat-FASTcaps";
  color: white;
  line-height: 63px;
  text-align: center;
  touch-action: none;
  position: relative;
  z-index: 10;
}
.instructions {
  text-align: center;
  margin-top: 50px;
  font-size: 34px;
}
.content {
  display: inline-block;
}
h2 {
  color: #c5d43b;
  font-size: 47px;
  line-height: 56px;
  position: absolute;
  bottom: 60px;
  right: 213px;
}
.drag-image {
  width: 278px;
  transform: translateY(-10%);
  img {
    width: 100%;
    height: auto;
  }
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 99999999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
.drag-container {
  position: absolute;
  top: 564px;
  left: 161px;
}
</style>

<template>
  <div class="slide-4">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module1/slide4/characters-01.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 3"
        src="@/assets/module1/slide4/text_boxes.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeUp" appear>
      <p v-show="slideIndex == 3" class="intro">
        {{ $t("module1.slide4.intro") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <h1
        v-show="slideIndex == 3"
        class="txtc delay-2"
        v-html="$t('module1.slide4.heading')"
      ></h1>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 3" class="dropzone delay-4">
        <div class="drop drop-1">{{ $t("module1.slide4.drop") }}</div>
        <div class="drop drop-2">{{ $t("module1.slide4.drop") }}</div>
        <div class="drop drop-3">{{ $t("module1.slide4.drop") }}</div>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div class="drag-image" v-show="slideIndex == 3">
        <img class="delay-2 " src="@/assets/module1/slide4/drag_drop.svg" />
      </div>
    </transition>
    <div class="content drag-container">
      <transition name="scale" appear>
        <div v-show="slideIndex == 3" class="delay-3">
          <div class="drag" v-dragbatman>
            <span>{{ $t("module1.slide4.button1") }}</span>
          </div>
        </div>
      </transition>
      <transition name="scale" appear>
        <div v-show="slideIndex == 3" class="delay-4">
          <div class="drag " v-dragpaw>
            <span>{{ $t("module1.slide4.button2") }}</span>
          </div>
        </div>
      </transition>
      <transition name="scale" appear>
        <div v-show="slideIndex == 3" class="delay-5">
          <div class="drag " v-dragcat>
            <span>{{ $t("module1.slide4.button3") }}</span>
          </div>
        </div>
      </transition>
      <transition name="scale" appear>
        <p
          v-show="slideIndex == 3"
          class="instructions delay-6"
          v-html="$t('module1.slide4.instructions')"
        ></p>
      </transition>
    </div>
    <transition name="fadeUp" appear>
      <h2 v-show="slideIndex == 3" class="delay-7">
        {{ $t("module1.slide4.heading2") }}
      </h2>
    </transition>
  </div>
</template>

<script>
// import interact from "interactjs";
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export default {
  props: ["slideIndex"],
  data() {
    return {
      point1: false,
      point2: false,
      point3: false,
      showVid: false
    };
  },
  directives: {
    dragbatman: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - 1320;
              var dy = point.y - 280;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: 1320, y: 280 };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == 1320 && this.endY == 280) {
              _this.point1 = true;
              _this.play();
            }
          }
        });
      }
    },
    dragpaw: {
      inserted(el, binding, vnode) {
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - 460;
              var dy = point.y - 210;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: 460, y: 210 };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == 460 && this.endY == 210) {
              _this.point2 = true;
              _this.play();
            }
          }
        });
      }
    },
    dragcat: {
      inserted(el, binding, vnode) {
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - 920;
              var dy = point.y - 140;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                return { x: 920, y: 140 };
              }
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == 920 && this.endY == 140) {
              _this.point3 = true;
              _this.play();
            }
          }
        });
      }
    }
  },
  mounted() {},
  methods: {
    play() {
      if (!(this.point1 && this.point2 && this.point3)) return;
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
